<template>
  <div class="queuePage">
    <Row :gutter="24" class="queuePageRow">
      <!-- 左边栏目 -->
      <Col class="leftContent">
        <div class="cateTabs" v-if="devices.length >= 0">
          <Tabs tabPosition="top" :defaultActiveKey="defaultDeviceId" @change="changCheckCate" @prevClick="()=>{}" @nextClick="()=>{}">
            <TabPane v-for="device in devices" :key="device.id" :tab="device.name">
              <queueLists ref="queue" :dataList="dataSource" @selectTableItem="selectTableItem" :defaultDeviceId="defaultDeviceId"></queueLists>
            </TabPane>
            <div slot="tabBarExtraContent" class="calendarWrap">
              <Icon type="left" @click="getLastDayTime" style="margin-right:10px;font-size:16px"/>
              <DatePicker :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" placeholder="请选择日期" v-model="queueDate" @change="selectQueueDate"/>
              <Icon type="right" @click="getNextDayTime" style="margin-left:16px;font-size:16px"/>
            </div>
          </Tabs>
        </div>
      </Col>
      <!-- 右边栏目 -->
      <Col class="rightContent" ref="rightC">
        <Card class="static">
          <div class="pageNumShow"><span style="margin-right:16px;">等待叫号：{{staticData.callNum}}</span> 当日检查单数：{{staticData.todayCheckNum}}</div>
        </Card>
        <Card class="mainOperate" v-if="this.isRole('ROLE_RIS') && !this.isRole('ROLE_ROOT') || this.isRole('ROLE_ROOT')">
          <!-- <Button type="primary" size="large" @click="openLineCheck">线上报到</Button> -->
          <Button type="primary" size="large" @click="addCheck">{{isAiCenter? '新增AI订单' :'新增检查'}}</Button>
        </Card>
        <Card class="operateCard">
          <Button v-if="this.isRole('ROLE_RIS') && !this.isRole('ROLE_ROOT') || this.isRole('ROLE_ROOT')" size="large" :disabled="!selectItem.showPrinter || selectItem.status === 8" @click="printReport">{{isAiCenter? '查看报告': '打印报告'}}</Button>
          <Button v-if="this.isRole('ROLE_RIS') && !this.isRole('ROLE_ROOT') || this.isRole('ROLE_ROOT')" size="large" :disabled="selectItem.status === 8" @click="editCheck">编辑详情</Button>
          <Button v-if="this.isRole('ROLE_RIS') && !this.isRole('ROLE_ROOT') || this.isRole('ROLE_ROOT')" size="large" :disabled="selectItem.status === 8" @click="surcharge">额外费用</Button>
          <Button v-if="this.isRole('ROLE_RIS') && !this.isRole('ROLE_ROOT') || this.isRole('ROLE_ROOT')" size="large" :disabled="selectItem.status === 8" @click="shootingMaterial">拍摄资料</Button><br>
          <Button v-if="this.isRole('ROLE_CHECK_OPERATING') && this.isRole('ROLE_RIS')" size="large" @click="cancelCheck" :disabled="[20, 50, 60].includes(selectItem.status)">取消检查</Button>
          <Button v-else-if="this.isRole('ROLE_CHECK_OPERATING') && !this.isRole('ROLE_RIS')" size="large" @click="cancelCheck" :disabled="[10, 50, 60, 20].includes(selectItem.status)">取消检查</Button>
          <Button v-else-if="!this.isRole('ROLE_CHECK_OPERATING') && this.isRole('ROLE_RIS')" size="large" @click="cancelCheck" :disabled="[50, 60, 20].includes(selectItem.status)">取消检查</Button>
          <Button v-if="this.isRole('ROLE_CHECK_OPERATING') && !this.isRole('ROLE_ROOT') || this.isRole('ROLE_ROOT')" size="large" @click="appointmentCheck">预约检查</Button>
          <Button v-if="this.isRole('ROLE_RIS') && !this.isRole('ROLE_ROOT') || this.isRole('ROLE_ROOT')" size="large" :disabled="selectItem.status !== 8" @click="arriveHospital">确认到院</Button>
        </Card>
        <Card class="checkPatient">
          <p>编写医生：{{selectItem.writeReportDoctor | changeDoctorName('write')}}</p>
          <p>审核医生：{{selectItem.reviewReportDoctor | changeDoctorName('check')}}</p>
          <p>生日：{{selectItem.birthday}}</p>
          <p>年龄：{{selectItem.age}}{{selectItem.ageUnit|getAgeUnit}}</p>
          <p>电话：{{selectItem.mobile}}</p>
          <p>既往病史：{{selectItem.medicalHistory}}</p>
          <p>备注：{{selectItem.remark}}</p>
        </Card>
      </Col>
    </Row>
    <!-- 取消检查 -->
    <Modal title="取消检查" v-model="cancel.showCancelCheck">
      <p>是否确认患者 {{cancel.patientName}} 取消检查（取消后不可恢复）？</p>
      <Row><span style="color: red">*</span>取消原因：</Row>
      <RadioGroup v-model="cancel.whyKey">
        <Radio :style="cancel.radioStyle" value="患者不适">患者不适</Radio>
        <Radio :style="cancel.radioStyle" value="设备异常">设备异常</Radio>
        <Radio :style="cancel.radioStyle" value="其他">其他</Radio>
      </RadioGroup>
      <div style="margin-left:24px;">
        <TextArea :disabled="cancel.whyKey !== '其他'" placeholder="请填写其他原因" v-model.trim="cancel.whyMsg" :autosize="{ minRows: 5, maxRows: 20 }"/>
      </div>
      <div slot="footer">
        <Button size="large" @click="closeCancelModal">返回</Button>
        <Button size="large" type="primary" @click="sureCancelCheck" :loading='sureCancelLoading'>确认取消</Button>
      </div>
    </Modal>
    <!-- 相关资料上传 -->
    <Modal title="相关资料" v-model="relInformation.openFlag" @cancel="closeRelInformation" @ok="uploadRelInformation" :width="800">
      <div class="uploadWrap">
        <div class="showWrap">
          <div>
            <img class="showArea" id="bigPriDev"/>
          </div>
          <div class="operatonWrap">
            <Button size="large" type="primary" :loading="relInformation.generateLoading" @click="takePhoto">{{relInformation.generateLoading?'生成照片中':'拍照'}}</Button>
            <Upload :beforeUpload="(file) => { addImageBefore(file); return false;}" :multiple="true" :showUploadList="false">
              <Button size="large" type="primary" :loading="relInformation.generateLoading" @click="takePhoto" style="margin-left: 16px;">
                <Icon type="upload" />
                <span>上传照片</span>
              </Button>
            </Upload>
          </div>
        </div>
        <div class="imageList">
          <div class="imageItem" v-for="(item, index) in relInformation.fileList" :key="index" style="">
            <img :src="item.url"/>
            <div class="actionWrap">
              <div @click="previewImage(item)"><Icon type="eye" style="font-size:16px;cursor:pointer;"></Icon></div>
              <div style="margin:0 10px;" @click="downLoadImage(item)"><Icon type="download" style="font-size:16px;cursor:pointer;"></Icon></div>
              <div @click="deleteImage(item,index)"><Icon type="delete" style="font-size:16px;cursor:pointer;"></Icon></div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="closeRelInformation">取消</Button>
        <Button type="primary" size="large" :loading="relInformation.saveBtnLoading" @click="uploadRelInformation">保存</Button>
      </div>
    </Modal>
    <Modal title="图片预览" :width="800"  :footer="null" v-model="relInformation.imagePreview" v-if="relInformation.imagePreview">
      <img v-if='relInformation.previewUrl' :src="relInformation.previewUrl" style="width:100%;"/>
    </Modal>
    <!-- 新增额外费用 -->
    <Modal title="额外费用"  v-model="showExtra" :footer="null" :width="680" class="modalFixdToTop">
      <extraCost class="extraCost" v-if="showExtra" @closeExtraCost="closeExtraCost" :checkOrderId="checkOrderId" :settlementStatus="settlementStatus"></extraCost>
    </Modal>
    <!-- 线上报到 -->
    <Modal title="线上报到"  v-model="showOnlineCheck" :footer="null" :width="680">
      <onlineCheck class="onlineCheck" v-if="showOnlineCheck" @removeOnlineModal="removeOnlineModal" :currentCenterId="currentCenterId"></onlineCheck>
    </Modal>
  </div>
</template>
<script>
import { Button, Row, Col, Tabs, DatePicker, Card, Modal, Icon, Radio, Input, Upload } from 'ant-design-vue'
import { queueUpList } from '../../api/reservation'
import { mapActions } from 'vuex'
import { toast, switchTimeFormat, getSession } from '../../libs/utils'
import queueLists from '../../components/queueLists/index'
import { nurseCancelCheck } from '../../api/check'
import { RelevantInformation, QueueList } from '../../libs/mixin'
import extraCost from '../historyCheck/extraCost'
import { changePrinter } from '../../api/report'
import onlineCheck from './onlineCheck'
import { getAiCheckImageCenterId } from '../../config'
export default {
  mixins: [RelevantInformation, QueueList],
  components: {
    queueLists,
    Button,
    Row,
    Col,
    Tabs,
    TabPane: Tabs.TabPane,
    DatePicker,
    Card,
    Radio,
    RadioGroup: Radio.Group,
    Modal,
    Icon,
    TextArea: Input.TextArea,
    extraCost,
    onlineCheck,
    Upload
  },
  data () {
    return {
      dataSource: [], //预约列表
      selectItem: {}, //选择的排队项目
      showReportTemplate: false,
      cancel: {
        showCancelCheck: false,
        whyKey: null,
        whyMsg: '',
        radioStyle: {
          display: 'block',
          height: '30px',
          lineHeight: '30px',
        },
        patientName: ''
      },
      showExtra: false,
      checkOrderId: '',
      staticData: {
        callNum: 0,
        todayCheckNum: 0,
      },
      callNum: 0,
      todayCheckNum: 0,
      newList: {},
      time: null,
      role: null,
      settlementStatus: '',
      sureCancelLoading: false,
      showOnlineCheck: false, // 线上报到
      isAiCenter: false
    }
  },
  async mounted () {
    this.role = getSession('userAuth', 'object').roles || null
    await this.initData()
    if (this.currentCenterId == getAiCheckImageCenterId()) {
      this.isAiCenter = true
    }
  },
  beforeDestroy () {
    clearInterval(this.time)
    this.time = null
  },
  methods: {
    ...mapActions(['setCurDevice']),
    async initData () {
      this.selectItem = {}
      await this.getQuenuList(this.defaultDeviceId)
    },
    // 自动刷新列表
    async autoGetList () {
      this.callNum = 0
      this.todayCheckNum = 0
      let params = {
        medicalImageCenterId: this.currentCenterId,
        medicalImageCenterDeviceId: this.defaultDeviceId || (this.devices && this.devices[0] && this.devices[0]['id']),
        queueUpDate: this.queueDate.format('YYYY-MM-DD'),
        isNurse: true
      }
      let data = await queueUpList(params)
      if (data) {
        data.nowCreateQueueUpList.list.forEach(val => {
          if (val.queueUpItemList && val.queueUpItemList.length === 1) {
            val.queueUpItemList.forEach(item => {
              this.forOldData(val, item, 0)
            })
          } else if (val.queueUpItemList && val.queueUpItemList.length > 1) {
            this.forMuchData(val, 0)
          } else if (!val.queueUpItemList) {
            this.forNullData(val, 0)
          }
          this.queueListStatic(val)
        })
        data.nextCreateQueueUpList.list.forEach(val => {
          if (val.queueUpItemList && val.queueUpItemList.length === 1) {
            val.queueUpItemList.forEach(item => {
              this.forOldData(val, item, 1)
            })
          } else if (val.queueUpItemList && val.queueUpItemList.length > 1) {
            this.forMuchData(val, 1)
          } else if (!val.queueUpItemList) {
            this.forNullData(val, 1)
          }
          this.queueListStatic(val)
        })
      }
    },
    // 目标数据不存在
    forNullData (newData, type) {
      this.dataSource && this.dataSource[type] && this.dataSource[type].list && this.dataSource[type].list.forEach(key => {
        if (key.queueUpItemList && !newData.queueUpItemList) {
          if (newData.timer === this.handelTime(key.timer)) {
            key.queueUpItemList = newData.queueUpItemList
          }
        }
        return
      })
    },
    // 目标数据为null or one 自动刷新循环oldData
    forOldData (newData, oldData, type) {
      this.dataSource && this.dataSource[type] && this.dataSource[type].list && this.dataSource[type].list.forEach(key => {
        if (key.queueUpItemList && key.queueUpItemList.length === 1) {
          for (let i = 0, len = key.queueUpItemList.length; i < len; i++) {
            if (newData.timer === this.handelTime(key.timer) && key.queueUpItemList[i].checkOrderId === oldData.checkOrderId) {
              Object.assign(key.queueUpItemList[i], oldData)
            }
          }
        } else if (!key.queueUpItemList) {
          if (newData.timer === this.handelTime(key.timer)) {
            key.queueUpItemList = newData.queueUpItemList
          }
        } else if (key.queueUpItemList && key.queueUpItemList.length > 1) {
          if (newData.timer === this.handelTime(key.timer)) {
            key.queueUpItemList = newData.queueUpItemList
          }
        }
        this.forReportList(key)
      })
    },
    // 目标数据为多个自动刷新循环oldData
    forMuchData (newData, type) {
      this.dataSource && this.dataSource[type] && this.dataSource[type].list && this.dataSource[type].list.forEach(key => {
        if (key.queueUpItemList) {
          if (newData.timer === this.handelTime(key.timer)) {
            key.queueUpItemList = newData.queueUpItemList
          }
        }
        this.forReportList(key)
      })
    },
    // 截取时间转化为数字
    handelTime (time) {
      let newTime = time.toString().replace(':', '')
      return +newTime
    },
    // 获取排队列表
    async getQuenuList (deviceId) {
      if (this.time) {
        clearInterval(this.time)
        this.time = null
      }
      this.dataSource = []
      this.callNum = 0
      this.todayCheckNum = 0
      let params = {
        medicalImageCenterId: this.currentCenterId,
        medicalImageCenterDeviceId: deviceId || (this.devices && this.devices[0] && this.devices[0]['id']),
        queueUpDate: this.queueDate.format('YYYY-MM-DD'),
        isNurse: true
      }
      let data = await queueUpList(params)
      if (data) {
        if (this.time) {
          clearInterval(this.time)
          this.time = null
        }
        this.time = setInterval(async () => {
          await this.autoGetList()
        }, 5000)
      }
      let nowDate = switchTimeFormat(new Date(), 7)
      let time = nowDate.slice(0, 5).toString().replace(':', '')
      if (data && data.nowCreateQueueUpList && data.nowCreateQueueUpList.list) {
        let interval = (this.handelTime(data.nowCreateQueueUpList.list[1].timer)) - (this.handelTime(data.nowCreateQueueUpList.list[0].timer))
        this.formatData(data.nowCreateQueueUpList.list)
        data.nowCreateQueueUpList.list.forEach(val => {
          this.addCurTimeLine(time, interval, val)
          this.forListAddActive(val)
          this.forReportList(val)
          this.queueListStatic(val)
        })
        this.$set(this.dataSource, 0, data.nowCreateQueueUpList)
      }
      if (data && data.nextCreateQueueUpList && data.nextCreateQueueUpList.list){
        let interval = (this.handelTime(data.nowCreateQueueUpList.list[1].timer)) - (this.handelTime(data.nowCreateQueueUpList.list[0].timer))
        this.formatData(data.nextCreateQueueUpList.list)
        data.nextCreateQueueUpList.list.forEach(val => {
          this.addCurTimeLine(time, interval, val)
          this.forListAddActive(val)
          this.forReportList(val)
          this.queueListStatic(val)
        })
        this.$set(this.dataSource, 1, data.nextCreateQueueUpList)
      }
    },
    // 遍历排队表 判断当前时间线的显示
    addCurTimeLine (time, interval, data) {
      if ((+time - this.handelTime(data.timer)) >= 0 && (+time - this.handelTime(data.timer)) < interval) {
        data.showLine = true
      } else {
        data.showLine = false
      }
    },
    // 遍历排队表 添加active
    forListAddActive (arr) {
      arr.queueUpItemList && arr.queueUpItemList.length > 0 && arr.queueUpItemList.forEach(val => {
        if (val.checkOrderId === this.selectItem.checkOrderId) {
          arr.active = true
          this.selectItem = val
          return
        } else arr.active = false
      })
    },
    // 遍历报告列表 让打印机图标显示
    forReportList (arr) {
      arr.queueUpItemList && arr.queueUpItemList.forEach(key => {
        if (key.reportList && key.reportList.length > 0) {
          key.reportList.forEach(item => {
            key.showPrinter = true
            key.reportId = item.reportId
            if (item.isPrinted) {
              key.isPrinted = false
            } else if (item.isPrinted === false) {
              key.isPrinted = true
            }
          })
        } else {
          key.isPrinted = null
          key.showPrinter = false
          key.reportId = null
        }
      })
    },
    // 遍历排队表统计
    queueListStatic (arr) {
      arr.queueUpItemList && arr.queueUpItemList.forEach(key => {
        if (key.status === 10) this.callNum += 1
        this.todayCheckNum += 1
      })
      this.$set(this.staticData, 'callNum', this.callNum)
      this.$set(this.staticData, 'todayCheckNum', this.todayCheckNum)
    },
    // 线上报到
    openLineCheck () {
      this.showOnlineCheck = true
    },
    removeOnlineModal () {
      this.showOnlineCheck = false
    },
    // 新增检查
    addCheck () {
      if (this.isRole('ROLE_CHECK_OPERATING') && !this.isRole('ROLE_RIS')) return toast({ title: '提示', type: 'warning', msg: '您没有权限操作此功能！' })
      this.$router.push({path: '/ris/addCheck', query: {isNurseEditFlag: true, addNewOrder: true}})
    },
    // 打印报告
    async printReport () {
      if (this.isRole('ROLE_CHECK_OPERATING') && !this.isRole('ROLE_RIS')) return toast({ title: '提示', type: 'warning', msg: '您没有权限操作此功能！' })
      if (!this.selectItem.checkOrderId) return toast({ title: '提示', type: 'warning', msg: '请选中其中一项检查！' })
      let data = await changePrinter({ reportId: this.selectItem.reportId })
      if (data) {
        this.$router.push({path: '/ris/printReport', query: { reportId: this.selectItem.reportId }})
      }
    },
    //编辑详情
    editCheck () {
      if (this.isRole('ROLE_CHECK_OPERATING') && !this.isRole('ROLE_RIS')) return toast({ title: '提示', type: 'warning', msg: '您没有权限操作此功能！' })
      if (!this.selectItem.checkOrderId) return toast({ title: '提示', type: 'warning', msg: '请选中其中一项检查！' })
      // 判断如果是在AI影像中心下如果当前用户ID跟创建的用户ID不一样，就不让他编辑
      if (this.isAiCenter) {
        let risUserInfo = getSession('risUserInfo', 'object')
        if (!risUserInfo) return false
        if ((this.selectItem.creatorId != risUserInfo.id) && !this.isRole('ROLE_ROOT')) return toast({ title: '提示', type: 'warning', msg: '请选择自己创建的检查单！' })
      }
      this.$router.push({path: '/ris/addCheck', query: {checkOrderId: this.selectItem.checkOrderId, from: 'queue', isNurseEditFlag: true}})
    },
    // 取消检查
    cancelCheck () {
      if (!this.selectItem.checkOrderId) return toast({ title: '提示', type: 'warning', msg: '请选中其中一项检查！' })
      // if ([10, 20, 50, 60, 70].includes(this.selectItem.status))
      this.cancel.showCancelCheck = true
    },
    // 关闭取消检查弹框
    closeCancelModal () {
      this.cancel.showCancelCheck = false
    },
    // 确认取消检查
    async sureCancelCheck () {
      let params = {
        id: this.selectItem.checkOrderId
      }
      if (!this.cancel.whyKey) return toast({ title: '提示', type: 'warning', msg: '请选择取消原因！' })
      if (this.cancel.whyKey && this.cancel.whyKey !== '其他') params.reason = this.cancel.whyKey
      if (this.cancel.whyKey && this.cancel.whyKey === '其他') params.reason = this.cancel.whyMsg
      if (this.sureCancelLoading) return false
      this.sureCancelLoading = true
      let data = await nurseCancelCheck(params)
      if (data) {
        toast({ title: '提示', type: 'success', msg: '取消检查成功！' })
        this.sureCancelLoading = false
        await this.getQuenuList()
      }
      this.closeCancelModal()
    },
    // 额外费用
    surcharge () {
      if (!this.selectItem.checkOrderId) return toast({ title: '提示', type: 'warning', msg: '请选中其中一项检查！' })
      if (this.isRole('ROLE_CHECK_OPERATING') && !this.isRole('ROLE_RIS')) return toast({ title: '提示', type: 'warning', msg: '您没有权限操作此功能！' })
      this.checkOrderId = this.selectItem.checkOrderId
      this.settlementStatus = this.selectItem.settlementStatus
      this.showExtra = true
    },
    // 关闭额外费用的弹框
    async closeExtraCost () {
      this.showExtra = false
    },
    // 选择某一项
    selectTableItem (record) {
      this.selectItem = record
    },
    // 判断角色
    isRole (code) {
      if (!this.role || this.role.length <= 0) return false
      for (let i = 0; i < this.role.length; i++) {
        if (this.role[i].rcode === code) return true
      }
      return false
    },
    // 预约检查
    async appointmentCheck () {
      this.$router.push({path: 'addCheck', query: { isAppointmentCheck: true, addNewOrder: true }})
    },
    // 到院检查
    arriveHospital () {
      if (!this.selectItem.checkOrderId) return toast({ title: '提示', type: 'warning', msg: '请选中其中一项检查！' })
      this.$router.push({path: 'addCheck', query: { checkOrderId: this.selectItem.checkOrderId, isInHospitalCheckFlag: true, from: 'queue', isNurseEditFlag: true }})
    }
  }
}
</script>
<style lang="less">
@import url('../../style/index.less');
// 页面样式
.queuePage{
  .clearBtnFocus();
  background-color: @pageBgColor;
  margin: @LeaveDistance;
  .queuePageRow {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: auto;
    margin: 0 !important;
  }
  .leftContent{
    flex: 1;
    background: #ffffff;
    .calendarWrap{
      display:flex;
      align-items:center;
      margin-top: 6px;
    }
    .ant-tabs-bar.ant-tabs-top-bar{
      min-width: 500px;
    }
  }
  @media all and (max-width: 1090px) {
    .rightContent{
      min-width: 252px;
      max-width: 252px;
      padding-left: 0 !important;
      padding-right: 0 !important;
      margin-left: 16px;
      overflow-x: hidden;
      overflow-y: auto;
      background-color: #fff;
      .static{
        height: 45px;
        .ant-card-body{
          padding: 0;
        }
        .pageNumShow{
          line-height: 45px;
          margin-left: @LeaveDistance;
          width: 100%;
        }
      }
      .ant-card-body{
        padding: @LeaveDistance;
      }
      .mainOperate{
        border:none;
        .ant-card-body{
          padding: 0;
        }
        button{
          // width: @auxiliaryBtnWidth;
          width: 85%;
          height: @mainBtnHeight;
          margin: @LeaveDistance 0 @LeaveDistance @LeaveDistance;
        }
      }
      .operateCard{
        border:none;
        .ant-card-body{
          padding: 0;
        }
        button{
          width: @auxiliaryBtnWidth;
          height: @auxiliaryBtnHeight;
          margin-left: @LeaveDistance;
          margin-bottom: @LeaveDistance;
        }
      }

    }
  }
  @media all and (min-width: 1090px) {
    .rightContent{
      max-width: 252px;
      padding-left: 0 !important;
      padding-right: 0 !important;
      margin-left: 16px;
      overflow-x: hidden;
      overflow-y: auto;
      background-color: #fff;
      .static{
        height: 45px;
        .ant-card-body{
          padding: 0;
        }
        .pageNumShow{
          line-height: 45px;
          margin-left: @LeaveDistance;
          width: 100%;
        }
      }
      .ant-card-body{
        padding: @LeaveDistance;
      }
      .mainOperate{
        border:none;
        .ant-card-body{
          padding: 0;
        }
        button{
          // width: @auxiliaryBtnWidth;
          width: 85%;
          height: @mainBtnHeight;
          margin: @LeaveDistance 0 @LeaveDistance @LeaveDistance;
        }
      }
      .operateCard{
        border:none;
        .ant-card-body{
          padding: 0;
        }
        button{
          width: @auxiliaryBtnWidth;
          height: @auxiliaryBtnHeight;
          margin-left: @LeaveDistance;
          margin-bottom: @LeaveDistance;
        }
      }
    }
  }
  .checkPatient{
    border-bottom: none;
    overflow-y: auto;
    height: 100%;
  }
}
// 上传资料样式
.uploadWrap{
  display: flex;
  .showWrap{
    .showArea{
      width: 400px;
      height: 400px;
      margin-right: 10px;
    }
    .operatonWrap{
      margin-top: 10px;
    }
  }
  .imageList{
    overflow: hidden;
    .imageItem{
      position:relative;
      width:104px;
      height:104px;
      float:left;
      margin: 0 8px 8px 0;
      border: 1px solid #d9d9d9;
      border-radius:4px;
      padding: 8px;
      img{
        width:86px;
        height:86px;
        object-fit:cover;
        position:relative;
        z-index:1;
      }
      .actionWrap{
        position:absolute;
        z-index:100;
        top:8px;
        left:8px;
        right:8px;
        bottom:8px;
        display:flex;
        align-items:center;
        justify-content: center;
        background-color:#333;
        color: #fff;
        opacity: 0.6;
      }
    }
  }
  // 兼容移动端
  @media all and (max-width: 576px) {
    .ant-row{
      display: block;
      position: static;
    }
    .rightContent{
      position: fixed;
      top: 0;
    }
  }
}

</style>